import Swiper from 'swiper/bundle'
/**
 * FooterLogosSlider component.
 * @author Dayne Coulson-Hoffacker
 */
export default class FooterLogosSlider {
  /**
   * Constructs a new FooterLogosSlider component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')

    const footerlogosSlider = new Swiper(this.swiperElement, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 0,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 0
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 0
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 30
        }
      },
      autoplay: {
       delay: 3000,
       disableOnInteraction: false
      },
    })
  }
}
